module.exports = __webpack_public_path__ + "img/cloud-snow.769fac46.svg";